<template>
  <div class="">
    <div class="flexbox gap-5 font-bold text-size-20" v-if="descriptions">
      <div v-html="descriptions"></div>
    </div>
    <div class="flexbox m-b-md justify-center box-base-table-search" v-if="isSearchable">
      <div v-if="!isSearchMultiple" class="flex-grow m-r-lg search-multiple">
        <input type="text" class="form-control text-center" v-model.trim="search" placeholder="ASIN、SKU、商品ID、商品ラベル、商品名の一部で検索可能です" @keydown.enter="onHandleSearchWithEnter">
        <button class="btn btn-warning ver-middle w-120" @click="onHandleSearch">フィルター</button>
      </div>
      <div v-else class="flex-grow sale-detail-search">
        <div class="search-block search-block-date datepicker-start">
          <label class="m-r-sm m-b-none">日付From </label>
          <div>
            <date-picker
              v-model="start"
              :not-after="end"
              placeholder=""
              ref="datepickerStart"
              format="YYYY/MM/DD"
              :lang="lang"
              @focusin.native="closePopup($refs.datepickerEnd)"
            ></date-picker>
          </div>
        </div>
        <div class="search-block search-block-date datepicker-end">
          <label class="m-r-sm m-b-none">日付To </label>
          <div>
            <date-picker
              v-model="end"
              :not-before="start"
              placeholder=""
              ref="datepickerEnd"
              format="YYYY/MM/DD"
              :lang="lang"
              @focusin.native="closePopup($refs.datepickerStart)"
            ></date-picker>
          </div>
        </div>
        <div class="search-block search-block-detail">
          <label class="m-r-sm m-b-none">明細 </label>
          <input type="text" class="form-control text-center" v-model.trim="detail" name="detail">
        </div>
        <div class="search-block search-block-mall">
          <label class="m-r-sm m-b-none"> モール </label>
          <select
              name="mallCode"
              class="form-control"
              v-model="mall"
            >
              <option
                :value="mall.mallCode"
                v-for="mall in malls"
                :key="mall.mallCode"
              >
                {{ mall.mallName }}
              </option>
            </select>
        </div>
        <div class="box-detail-btn-search">
          <button class="btn btn-warning ver-middle w-120" @click="onHandleSearch">フィルター</button>
        </div>
      </div>
    </div>
    <div v-if="isShowBtnBulkCreate && checkedItems.length" class="box-add-checked-all m-b-sm flexbox gap-10">
      <button type="button" class="btn btn-warning btn-add-checked-all" @click="bulkAdd()">選択した商品を追加</button>
      <span v-if="isShippingAmazon" class="font-bold text-size-20">※ACROSS在庫数が0の商品は選択できません</span>
    </div>
    <div v-if="isHideNoItem">※在庫0の商品は表示されません。</div>
    <div class="table-wrapper" ref="table">
      <table class="table table-bordered common-table widthedTable" :class="tableClass">
        <thead>
          <tr class="align-middle">
            <th
              v-for="(column, index) in columns"
              :class="[{ 'pointer-cursor': isSortable(column.sortable)}, column.headerClass]"
              :key="index"
              :style="{width: column.width, 'text-align': column.textAlign, 'background-color': column.bgColor, 'color': column.color}"
              @click="sortColumn(column.name, column.sortable, column.customSort)"
              v-html="renderTitle(column)"
            >
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!initial && countTableData() === 0">
            <td :colspan="columns.length" align="center" class="bg-danger text-danger"><h5 style="font-weight: 600">データが見つかりません。</h5></td>
          </tr>
          <tr v-for="(item, index) in pageData" :key="index" :class="bgColor(item.judgmentStatusCode)" @click="selectRowRequest(item)" v-else>
            <td
              v-for="(column, colIndex) in columns"
              :key="index + '-' + colIndex"
              :class="column.cellClass"
              :style="{width: column.width}"
            >
              <template v-if="column.customCell">
                <slot :name="column.name" :row-data="item" :handle-data="handleData" :data="defaultData"></slot>
                <details v-if="column.detailAmountCell">
                  <summary class='text-left'>内訳</summary>
                  <p>{{ item.amountDetails }}</p>
                </details>
                <details v-if="column.detailTransactionCell">
                  <summary class='text-left'>内訳</summary>
                  <p>{{ item.transactionDetails }}</p>
                </details>
              </template>
              <template v-else>
                <span>
                  {{ item[column.name] }}
                </span>
              </template>
            </td>
          </tr>
        </tbody>
      </table>
      <pagination
        :url="this.url"
        :extraUrl="this.extraUrl"
        :extraUrlMode="this.extraUrlMode"
        @onChangePage="onChangePage"
        @zIndex="$emit('zIndex', $event)"
        @originalData="getOriginalData"
        :keyword="this.keyword"
        :needExtraData="needExtraData"
        :maxRows="maxRows"
        :loadingTableMode="loadingTableMode"
        :clientMode="clientMode"
        :needLoading="needLoading"
        :method="method"
        ref="pagination"
      />
    </div>
  </div>
</template>
<script>
import Pagination from '@/view/warehouseAcross/components/Pagination'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  components: {
    DatePicker,
    Pagination
  },
  data () {
    return {
      column: null,
      sort: null,
      pageData: [],
      defaultData: [],
      originalData: [],
      search: this.searchValue || null,
      keyword: this.searchValue || null,
      initial: true,
      start: null,
      end: null,
      detail: null,
      mall: null,
      lang: {
        days: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
        pickers: ['1週間後', '1ヶ月後', '1週間前', '1ヶ月前'],
        placeholder: {
          date: '日付を選択',
          dateRange: '期間を選択'
        }
      },
      checkAll: false,
      storageDeliverySelectedProducts: []
    }
  },
  props: {
    url: {
      type: String,
      default: ''
    },
    isShippingAmazon: {
      type: Boolean,
      default: false
    },
    descriptions: {
      type: String,
      default: ''
    },
    columns: {
      type: Array
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    isHideNoItem: {
      type: Boolean,
      default: false
    },
    tableClass: {
      type: String,
      default: ''
    },
    searchValue: {
      type: String,
      default: ''
    },
    needExtraData: {
      type: Boolean,
      default: false
    },
    maxRows: {
      type: Number,
      default: 300
    },
    loadingTableMode: {
      type: Boolean,
      default: false
    },
    clientMode: {
      type: Boolean,
      default: false
    },
    extraUrl: {
      type: Array
    },
    extraUrlMode: {
      type: Boolean,
      default: false
    },
    needLoading: {
      type: Boolean,
      default: true
    },
    isSearchMultiple: {
      type: Boolean,
      default: false
    },
    method: {
      type: String,
      default: 'get'
    },
    malls: {
      type: Array,
      default: null
    },
    checkedItems: {
      type: Array,
      default () {
        return []
      }
    },
    isShowBtnBulkCreate: {
      type: Boolean,
      default: false
    },
    selectedProducts: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUser'
    })
  },
  methods: {
    closePopup (dom) {
      dom.closePopup()
    },
    getOriginalData (data) {
      this.originalData = [...data]
    },
    /*
     * Handle on page change
     *
     * @param {Array} data All Data for table from API
     * @param {Object} extraData Extra data get from API
     * @param {Boolean} needClear Nead clear previous data to store a new one
     *
     * @return void
     */
    onChangePage (data, extraData, needClear, keepSort, newData) {
      this.defaultData = [...data]
      this.pageData = newData && newData.length > 0 ? [
        ...this.pageData,
        ...newData
      ] : [...data]
      let selectedItemIds = this.selectedProducts.map(item => item.itemId)
      this.defaultData = this.defaultData.filter(item => !selectedItemIds.includes(item.itemId))
      this.pageData = this.pageData.filter(item => !selectedItemIds.includes(item.itemId))

      if (this.isHideNoItem) {
        this.pageData = this.pageData.filter((data) => (data.numberOfStock !== '0' && data.numberOfStock !== 0))
      }
      if (keepSort) {
        this.pageData = this.defaultSort()
      } else {
        this.column = null
        this.name = null
      }
      if (this.initial) {
        this.initial = false
      }
      if (this.needExtraData) {
        this.$emit('extraData', extraData)
      }
    },
    /*
     * Render icon sort for each sort type of column (only for sortable column)
     *
     * @param {String} name Column's name
     *
     * @return {String}
     */
    iconSort (name) {
      if (this.column === name && this.sort) {
        return this.sort === 'asc' ? 'fa-sort-up' : 'fa-sort-down'
      }
      return 'fa-sort'
    },
    /*
     * Handle onclick sort data
     *
     * @param {String} name Column's name
     * @param {Boolean} sortable Column is sortable or not
     * @param {Function} customSort Column is sortable or not
     *
     * @return void
     */
    sortColumn (name, sortable, customSort) {
      if (name === 'checkBoxAll') {
        this.checkAll = !this.checkAll
        this.$emit('checkBoxAll', this.checkAll)
      }
      if (!this.isSortable(sortable) || this.defaultData.length <= 1) return
      if (this.column !== name) this.sort = null
      this.column = name
      if (!this.sort) {
        this.sort = 'desc'
      } else if (this.sort === 'desc') {
        this.sort = 'asc'
      } else {
        this.sort = null
      }
      this.pageData = customSort ? customSort(this.defaultData, this.sort, name) : this.reOrderData(name, this.sort)
    },
    /*
     * Reorder data by current choosen column with approriate sort type
     *
     * @param {String} name Column's name
     * @param {String} order Sort's type (asc / desc / null)
     *
     * @return {Array}
     */
    reOrderData (name, order) {
      if (!order) {
        return [...this.defaultData]
      } else if (order === 'desc') {
        return [...this.defaultData].sort((before, after) => this.orderCallback(after, before, name))
      }
      return [...this.defaultData].sort((before, after) => this.orderCallback(before, after, name))
    },
    /*
     * Ordering callback
     *
     * @param {Object} before Left item
     * @param {Object} after Right item
     * @param {String} name Column's name
     *
     * @return {Boolean}
     */
    orderCallback (before, after, name) {
      return (
        (!isNaN(before[name]) && !isNaN(after[name])) ||
        (typeof before[name] === 'undefined' || typeof after[name] === 'undefined')
      ) ? before[name] - after[name] : ((after[name] === null) - (before[name] === null)) || before[name].localeCompare(after[name])
    },
    /*
     * Check column is sortable or not
     *
     * @param {Boolean} sortable Column sortable declaration
     *
     * @return {Boolean}
     */
    isSortable (sortable) {
      return sortable || typeof sortable === 'undefined'
    },
    /*
     * Handle change data from parent component
     *
     * @param {Object} item Record to be changed
     * @param {String} type Type of changed
     * @param {Boolean} isCallApi Need to call API
     *
     * @return void
     */
    handleData (item, type, isCallApi = false) {
      this.$refs.pagination.handleData(item, type, isCallApi, false, true)
    },
    /*
     * Initial sort when data changed
     *
     * @return {Array}
     */
    defaultSort () {
      const columnCustomSort = this.columns.filter((column) => column.name === this.column && column.customSort)
      return columnCustomSort.length > 0 ? columnCustomSort[0].customSort(this.defaultData, this.sort, name) : this.reOrderData(this.column, this.sort)
    },
    renderTitle (column) {
      let icon = this.isSortable(column.sortable) ? this.renderIconTag(['fa', this.iconSort(column.name)]) : ''
      return column.title + ' ' + icon
    },
    renderIconTag (classes) {
      return `<i class="${classes.join(' ')}"></i>`
    },
    countTableData () {
      if (this.defaultData === null) {
        return 0
      }
      return this.defaultData.length
    },
    onHandleSearchWithEnter (e) {
      if (e.keyCode !== 13) return

      this.onHandleSearch()
    },
    /*
     * Handle onclick search button
     *
     * @return void
     */
    onHandleSearch () {
      if (this.isSearchMultiple) {
        this.keyword = {
          startOfferDate: this.start ? moment(this.start).format('YYYY/MM/DD') : null,
          endOfferDate: this.end ? moment(this.end).format('YYYY/MM/DD') : null,
          detail: this.detail
        }
        if (this.mall) {
          this.keyword.mallCode = [this.mall]
        }
      } else {
        this.keyword = this.search
      }
      this.$emit('keyword', this.keyword)
    },
    /*
     * Handle onclick reload button
     *
     * @param {Boolean} showLoading Need show loading for table
     * @param {Boolean} keepKeyword Is remove current keyword or not
     *
     * @return void
     */
    reload (showLoading = false, keepKeyword = false, needAll = false, forceClient = false) {
      if (keepKeyword) {
        this.$refs.pagination.reload(false, needAll, forceClient)
      } else {
        this.search = null
        const oldKeyword = this.keyword
        this.keyword = forceClient ? '' : null
        if (oldKeyword === null) {
          this.$refs.pagination.reload(showLoading, needAll, forceClient)
        }
      }
    },
    bgColor (judgmentStatusCode) {
      if (judgmentStatusCode === '8' || judgmentStatusCode === '9') {
        return 'bg-danger'
      }
    },
    selectRowRequest (event) {
      this.$emit('clickRow', event)
    },
    bulkAdd () {
      this.$emit('bulkAdd')
    }
  },
  mounted () {
    $('.datepicker-start .mx-input-append').click((evt) => {
      $('.datepicker-start .mx-input').focus()
    })
    $('.datepicker-end .mx-input-append').click((evt) => {
      $('.datepicker-end .mx-input').focus()
    })
  },
  watch: {
    defaultData () {
      if (!this.keyword) {
        this.$emit('countData', this.countTableData())
      }
    },
    search () {
      if (this.isSearchable) {
        this.$emit('onChangeSearch', this.search)
      }
    },
    searchValue () {
      this.keyword = this.searchValue
    },
    checkedItems: {
      handler (arrCheckedItems) {
        if (arrCheckedItems.length === 0 && this.defaultData.length) {
          this.checkAll = false
          $('#checkbox-all').attr('checked', false)
        }
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/warehouseAcross/components/TableShippingProductAdd.vue